import { useMultiStyleConfig } from '@hover/blueprint/chakra';
import { useReducer, useCallback, useRef, useEffect } from 'react';
import { useBoolean, useLatestCallback, useEventListener, motion, system, useIsInitialRender, SimpleGrid, AspectRatio, Image as Image$1, Center, Icon, LoadingState, forwardRef, IconButton, useIsMotionReduced, onSwipe, Modal, Body, Spacer, Heading, useZoom, HStack, Hotkey } from '@hover/blueprint';
import { iMaximize, iChevronLeft, iChevronRight, iconArrowLeft, iconArrowRight, hUpDown, iArrowLeft, iArrowRight } from '@hover/icons';
import { AnimatePresence, MotionConfig } from 'framer-motion';
import { createContext, mergeRefs } from '@chakra-ui/react-utils';
import { callAllHandlers } from '@chakra-ui/shared-utils';
import { assertUnreachable, includes } from '@hover/utilities';
import { jsx, jsxs, Fragment } from '@emotion/react/jsx-runtime';
import { resetFocus } from '@hover/blueprint/foundation';
import { createElement } from '@emotion/react';

function toPrimitive(t, r) {
  if ("object" != typeof t || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != typeof i) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}

function toPropertyKey(t) {
  var i = toPrimitive(t, "string");
  return "symbol" == typeof i ? i : i + "";
}

function _defineProperty(obj, key, value) {
  key = toPropertyKey(key);
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}

function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread2(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _iterableToArrayLimit(r, l) {
  var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (null != t) {
    var e,
      n,
      i,
      u,
      a = [],
      f = !0,
      o = !1;
    try {
      if (i = (t = t.call(r)).next, 0 === l) {
        if (Object(t) !== t) return;
        f = !1;
      } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
    } catch (r) {
      o = !0, n = r;
    } finally {
      try {
        if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return;
      } finally {
        if (o) throw n;
      }
    }
    return a;
  }
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
  return arr2;
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

var _createContextUtil = /*#__PURE__*/createContext({
    name: "GalleryStylesContext",
    errorMessage: "useGalleryStyles returned is 'undefined'. Seems you forgot to wrap the components in \"<GalleryStylesProvider />\" "
  }),
  _createContextUtil2 = /*#__PURE__*/_slicedToArray(_createContextUtil, 2),
  GalleryStylesProvider = _createContextUtil2[0],
  useGalleryStyles = _createContextUtil2[1];

function _regeneratorRuntime() {
  _regeneratorRuntime = function () {
    return e;
  };
  var t,
    e = {},
    r = Object.prototype,
    n = r.hasOwnProperty,
    o = Object.defineProperty || function (t, e, r) {
      t[e] = r.value;
    },
    i = "function" == typeof Symbol ? Symbol : {},
    a = i.iterator || "@@iterator",
    c = i.asyncIterator || "@@asyncIterator",
    u = i.toStringTag || "@@toStringTag";
  function define(t, e, r) {
    return Object.defineProperty(t, e, {
      value: r,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }), t[e];
  }
  try {
    define({}, "");
  } catch (t) {
    define = function (t, e, r) {
      return t[e] = r;
    };
  }
  function wrap(t, e, r, n) {
    var i = e && e.prototype instanceof Generator ? e : Generator,
      a = Object.create(i.prototype),
      c = new Context(n || []);
    return o(a, "_invoke", {
      value: makeInvokeMethod(t, r, c)
    }), a;
  }
  function tryCatch(t, e, r) {
    try {
      return {
        type: "normal",
        arg: t.call(e, r)
      };
    } catch (t) {
      return {
        type: "throw",
        arg: t
      };
    }
  }
  e.wrap = wrap;
  var h = "suspendedStart",
    l = "suspendedYield",
    f = "executing",
    s = "completed",
    y = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  var p = {};
  define(p, a, function () {
    return this;
  });
  var d = Object.getPrototypeOf,
    v = d && d(d(values([])));
  v && v !== r && n.call(v, a) && (p = v);
  var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p);
  function defineIteratorMethods(t) {
    ["next", "throw", "return"].forEach(function (e) {
      define(t, e, function (t) {
        return this._invoke(e, t);
      });
    });
  }
  function AsyncIterator(t, e) {
    function invoke(r, o, i, a) {
      var c = tryCatch(t[r], t, o);
      if ("throw" !== c.type) {
        var u = c.arg,
          h = u.value;
        return h && "object" == typeof h && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) {
          invoke("next", t, i, a);
        }, function (t) {
          invoke("throw", t, i, a);
        }) : e.resolve(h).then(function (t) {
          u.value = t, i(u);
        }, function (t) {
          return invoke("throw", t, i, a);
        });
      }
      a(c.arg);
    }
    var r;
    o(this, "_invoke", {
      value: function (t, n) {
        function callInvokeWithMethodAndArg() {
          return new e(function (e, r) {
            invoke(t, n, e, r);
          });
        }
        return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
      }
    });
  }
  function makeInvokeMethod(e, r, n) {
    var o = h;
    return function (i, a) {
      if (o === f) throw Error("Generator is already running");
      if (o === s) {
        if ("throw" === i) throw a;
        return {
          value: t,
          done: !0
        };
      }
      for (n.method = i, n.arg = a;;) {
        var c = n.delegate;
        if (c) {
          var u = maybeInvokeDelegate(c, n);
          if (u) {
            if (u === y) continue;
            return u;
          }
        }
        if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) {
          if (o === h) throw o = s, n.arg;
          n.dispatchException(n.arg);
        } else "return" === n.method && n.abrupt("return", n.arg);
        o = f;
        var p = tryCatch(e, r, n);
        if ("normal" === p.type) {
          if (o = n.done ? s : l, p.arg === y) continue;
          return {
            value: p.arg,
            done: n.done
          };
        }
        "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg);
      }
    };
  }
  function maybeInvokeDelegate(e, r) {
    var n = r.method,
      o = e.iterator[n];
    if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y;
    var i = tryCatch(o, e.iterator, r.arg);
    if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y;
    var a = i.arg;
    return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y);
  }
  function pushTryEntry(t) {
    var e = {
      tryLoc: t[0]
    };
    1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e);
  }
  function resetTryEntry(t) {
    var e = t.completion || {};
    e.type = "normal", delete e.arg, t.completion = e;
  }
  function Context(t) {
    this.tryEntries = [{
      tryLoc: "root"
    }], t.forEach(pushTryEntry, this), this.reset(!0);
  }
  function values(e) {
    if (e || "" === e) {
      var r = e[a];
      if (r) return r.call(e);
      if ("function" == typeof e.next) return e;
      if (!isNaN(e.length)) {
        var o = -1,
          i = function next() {
            for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next;
            return next.value = t, next.done = !0, next;
          };
        return i.next = i;
      }
    }
    throw new TypeError(typeof e + " is not iterable");
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", {
    value: GeneratorFunctionPrototype,
    configurable: !0
  }), o(GeneratorFunctionPrototype, "constructor", {
    value: GeneratorFunction,
    configurable: !0
  }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) {
    var e = "function" == typeof t && t.constructor;
    return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name));
  }, e.mark = function (t) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t;
  }, e.awrap = function (t) {
    return {
      __await: t
    };
  }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () {
    return this;
  }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) {
    void 0 === i && (i = Promise);
    var a = new AsyncIterator(wrap(t, r, n, o), i);
    return e.isGeneratorFunction(r) ? a : a.next().then(function (t) {
      return t.done ? t.value : a.next();
    });
  }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () {
    return this;
  }), define(g, "toString", function () {
    return "[object Generator]";
  }), e.keys = function (t) {
    var e = Object(t),
      r = [];
    for (var n in e) r.push(n);
    return r.reverse(), function next() {
      for (; r.length;) {
        var t = r.pop();
        if (t in e) return next.value = t, next.done = !1, next;
      }
      return next.done = !0, next;
    };
  }, e.values = values, Context.prototype = {
    constructor: Context,
    reset: function (e) {
      if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t);
    },
    stop: function () {
      this.done = !0;
      var t = this.tryEntries[0].completion;
      if ("throw" === t.type) throw t.arg;
      return this.rval;
    },
    dispatchException: function (e) {
      if (this.done) throw e;
      var r = this;
      function handle(n, o) {
        return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o;
      }
      for (var o = this.tryEntries.length - 1; o >= 0; --o) {
        var i = this.tryEntries[o],
          a = i.completion;
        if ("root" === i.tryLoc) return handle("end");
        if (i.tryLoc <= this.prev) {
          var c = n.call(i, "catchLoc"),
            u = n.call(i, "finallyLoc");
          if (c && u) {
            if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
            if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
          } else if (c) {
            if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
          } else {
            if (!u) throw Error("try statement without catch or finally");
            if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
          }
        }
      }
    },
    abrupt: function (t, e) {
      for (var r = this.tryEntries.length - 1; r >= 0; --r) {
        var o = this.tryEntries[r];
        if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) {
          var i = o;
          break;
        }
      }
      i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null);
      var a = i ? i.completion : {};
      return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a);
    },
    complete: function (t, e) {
      if ("throw" === t.type) throw t.arg;
      return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y;
    },
    finish: function (t) {
      for (var e = this.tryEntries.length - 1; e >= 0; --e) {
        var r = this.tryEntries[e];
        if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y;
      }
    },
    catch: function (t) {
      for (var e = this.tryEntries.length - 1; e >= 0; --e) {
        var r = this.tryEntries[e];
        if (r.tryLoc === t) {
          var n = r.completion;
          if ("throw" === n.type) {
            var o = n.arg;
            resetTryEntry(r);
          }
          return o;
        }
      }
      throw Error("illegal catch attempt");
    },
    delegateYield: function (e, r, n) {
      return this.delegate = {
        iterator: values(e),
        resultName: r,
        nextLoc: n
      }, "next" === this.method && (this.arg = t), y;
    }
  }, e;
}

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }
  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}
function _asyncToGenerator(fn) {
  return function () {
    var self = this,
      args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);
      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }
      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }
      _next(undefined);
    });
  };
}

var _excluded$7 = ["children"];
var nextIndex = function nextIndex(images, index) {
  return index === images.length - 1 ? 0 : index + 1;
};
var previousIndex = function previousIndex(images, index) {
  return index === 0 ? images.length - 1 : index - 1;
};
var nextImage = function nextImage(images, index) {
  return images[nextIndex(images, index)];
};
var previousImage = function previousImage(images, index) {
  return images[previousIndex(images, index)];
};
var preload = function preload(_ref) {
  var url = _ref.url;
  return new Promise(function (resolve, reject) {
    var image = new Image();
    image.onload = resolve;
    image.onerror = reject;
    image.src = url;
  });
};
var reducer = function reducer(state, action) {
  var index = state.currentIndex,
    images = state.images;
  var updated = function () {
    switch (action.type) {
      case 'next':
        {
          return _objectSpread2(_objectSpread2({}, state), {}, {
            currentIndex: nextIndex(images, index)
          });
        }
      case 'previous':
        {
          return _objectSpread2(_objectSpread2({}, state), {}, {
            currentIndex: previousIndex(images, index)
          });
        }
      case 'close':
        return _objectSpread2(_objectSpread2({}, state), {}, {
          isOpen: false
        });
      case 'open':
        if (action.index !== state.currentIndex) return state;
        return _objectSpread2(_objectSpread2({}, state), {}, {
          isOpen: true
        });
      case 'select':
        return _objectSpread2(_objectSpread2({}, state), {}, {
          currentIndex: action.index
        });
      default:
        return assertUnreachable(action);
    }
  }();
  return _objectSpread2(_objectSpread2({}, updated), {}, {
    currentImage: images[updated.currentIndex],
    action: action.type
  });
};
var _createContext = /*#__PURE__*/createContext({
    name: 'GalleryContext',
    strict: true
  }),
  _createContext2 = /*#__PURE__*/_slicedToArray(_createContext, 2),
  Provider = _createContext2[0],
  useContext = _createContext2[1];

/**
 * Custom hook to retrieve the gallery context.
 *
 * @template TImage - The type of the images in the gallery, which extends `GalleryImage`.
 * @returns {GalleryContext<TImage>} The gallery context.
 */
var useGalleryContext = function useGalleryContext() {
  return useContext();
};
/**
 * Custom hook to manage a gallery of images with navigation and loading states.
 *
 * @template TImage - The type of the gallery image.
 * @param {TImage[]} props.images - The array of images to display in the gallery.
 * @param {number} [props.currentIndex=0] - The initial index of the current image.
 * @param {boolean} props.isOpen - Whether the gallery is open.
 * @param {boolean} [props.isExpanded=true] - Whether the gallery is expanded to show all images.
 * @param {object} [props.keys={ next: 'ArrowRight', previous: 'ArrowLeft' }] - The keyboard keys for navigation.
 * @param {string} [props.nextLabel='Next'] - The label for the next button.
 * @param {string} [props.previousLabel='Previous'] - The label for the previous button.
 * @param {string} [props.progressText='Photo {current} of {total}'] - The text template for the progress indicator.
 * @param {number} [props.limit] - The limit of images to show when the gallery is not expanded.
 */
var useGallery = function useGallery(_ref2) {
  var imagesProp = _ref2.images,
    _ref2$currentIndex = _ref2.currentIndex,
    currentIndexProp = _ref2$currentIndex === void 0 ? 0 : _ref2$currentIndex,
    isOpen = _ref2.isOpen,
    _ref2$isExpanded = _ref2.isExpanded,
    isExpanded = _ref2$isExpanded === void 0 ? true : _ref2$isExpanded,
    _ref2$keys = _ref2.keys,
    keys = _ref2$keys === void 0 ? {
      next: 'ArrowRight',
      previous: 'ArrowLeft'
    } : _ref2$keys,
    _ref2$nextLabel = _ref2.nextLabel,
    nextLabel = _ref2$nextLabel === void 0 ? 'Next' : _ref2$nextLabel,
    _ref2$previousLabel = _ref2.previousLabel,
    previousLabel = _ref2$previousLabel === void 0 ? 'Previous' : _ref2$previousLabel,
    _ref2$progressText = _ref2.progressText,
    progressText = _ref2$progressText === void 0 ? 'Photo {current} of {total}' : _ref2$progressText,
    limit = _ref2.limit;
  var _useReducer = useReducer(reducer, {
      isOpen: false,
      currentIndex: currentIndexProp,
      images: imagesProp,
      action: 'close',
      currentImage: imagesProp[currentIndexProp]
    }),
    _useReducer2 = _slicedToArray(_useReducer, 2),
    reduced = _useReducer2[0],
    dispatch = _useReducer2[1];
  var _useBoolean = useBoolean(),
    _useBoolean2 = _slicedToArray(_useBoolean, 2),
    isDisabled = _useBoolean2[0],
    _useBoolean2$ = _useBoolean2[1],
    disable = _useBoolean2$.on,
    enable = _useBoolean2$.off;
  var _useBoolean3 = useBoolean(),
    _useBoolean4 = _slicedToArray(_useBoolean3, 2),
    isLoading = _useBoolean4[0],
    _useBoolean4$ = _useBoolean4[1],
    loading = _useBoolean4$.on,
    loaded = _useBoolean4$.off;
  var images = reduced.images,
    currentIndex = reduced.currentIndex;
  var startLoading = useCallback(function () {
    loading();
    disable();
  }, [disable, loading]);
  var endLoading = useLatestCallback(function () {
    var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : -1;
    if (index !== -1 && index !== currentIndex) return;
    loaded();
    enable();
  }, [currentIndex, enable, loaded]);
  var state = _objectSpread2(_objectSpread2({}, reduced), {}, {
    isOpen: isOpen !== null && isOpen !== void 0 ? isOpen : reduced.isOpen,
    thumbnails: isExpanded ? reduced.images : reduced.images.slice(0, limit !== null && limit !== void 0 ? limit : reduced.images.length)
  });
  var nextButtonRef = useRef(null);
  var previousButtonRef = useRef(null);
  var next = useCallback(function () {
    if (isDisabled) return;
    startLoading();
    preload(nextImage(images, currentIndex))["finally"](function () {
      endLoading();
      dispatch({
        type: 'next'
      });
    });
  }, [currentIndex, endLoading, images, isDisabled, startLoading]);
  var previous = useCallback(function () {
    if (isDisabled) return;
    startLoading();
    preload(previousImage(images, currentIndex))["finally"](function () {
      endLoading();
      dispatch({
        type: 'previous'
      });
    });
  }, [currentIndex, endLoading, images, isDisabled, startLoading]);
  var getNextButtonProps = useCallback(function () {
    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    return {
      'aria-label': nextLabel,
      ref: mergeRefs(ref, nextButtonRef),
      onClick: callAllHandlers(props.onClick, next)
    };
  }, [next, nextLabel]);
  var getPreviousButtonProps = useCallback(function () {
    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    return {
      'aria-label': previousLabel,
      ref: mergeRefs(ref, previousButtonRef),
      onClick: callAllHandlers(props.onClick, previous)
    };
  }, [previous, previousLabel]);
  useEventListener('keydown', function (event) {
    var _previousButtonRef$cu, _nextButtonRef$curren;
    if (!state.isOpen || !keys) return;

    // eslint-disable-next-line default-case
    switch (event.key) {
      case keys.previous:
        previous();
        (_previousButtonRef$cu = previousButtonRef.current) === null || _previousButtonRef$cu === void 0 || _previousButtonRef$cu.focus();
        return;
      case keys.next:
        next();
        (_nextButtonRef$curren = nextButtonRef.current) === null || _nextButtonRef$curren === void 0 || _nextButtonRef$curren.focus();
    }
  });
  var progress = progressText.replace('{current}', (state.currentIndex + 1).toString()).replace('{total}', state.images.length.toString());
  return _objectSpread2(_objectSpread2({}, state), {}, {
    isDisabled: isDisabled,
    isLoading: isLoading,
    progress: progress,
    next: next,
    previous: previous,
    close: useCallback(function () {
      return dispatch({
        type: 'close'
      });
    }, [dispatch]),
    open: useCallback( /*#__PURE__*/function () {
      var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(index) {
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              dispatch({
                type: 'select',
                index: index
              });
              startLoading();
              _context.next = 4;
              return preload(images[index]);
            case 4:
              dispatch({
                type: 'open',
                index: index
              });
              endLoading(index);
            case 6:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      return function (_x) {
        return _ref3.apply(this, arguments);
      };
    }(), [endLoading, images, startLoading]),
    getNextButtonProps: getNextButtonProps,
    getPreviousButtonProps: getPreviousButtonProps,
    enable: enable,
    disable: disable
  });
};
var GalleryProvider = function GalleryProvider(_ref4) {
  var children = _ref4.children,
    props = _objectWithoutProperties(_ref4, _excluded$7);
  var value = useGallery(props);
  return jsx(Provider, {
    value: value,
    children: children
  });
};

var _excluded$6 = ["isMotionReduced", "showHover"];
var variants = {
  enter: {
    opacity: 1
  },
  exit: function exit(i) {
    return {
      opacity: 0,
      transition: {
        delay: i * 0.05
      }
    };
  }
};
var MotionButton = /*#__PURE__*/motion(system.button);
var GalleryGrid = function GalleryGrid(_ref) {
  _ref.isMotionReduced;
    var _ref$showHover = _ref.showHover,
    showHover = _ref$showHover === void 0 ? true : _ref$showHover,
    props = _objectWithoutProperties(_ref, _excluded$6);
  var styles = useGalleryStyles();
  var _useGalleryContext = useGalleryContext(),
    open = _useGalleryContext.open,
    thumbnails = _useGalleryContext.thumbnails,
    images = _useGalleryContext.images,
    currentIndex = _useGalleryContext.currentIndex,
    isLoading = _useGalleryContext.isLoading;
  var isInitialRender = useIsInitialRender();
  return jsx(SimpleGrid, _objectSpread2(_objectSpread2({}, props), {}, {
    children: jsx(AnimatePresence, {
      children: thumbnails.map(function (_ref2, index) {
        var url = _ref2.url,
          title = _ref2.title,
          thumbnail = _ref2.thumbnail;
        return jsxs(MotionButton, {
          __css: styles.gridElementButton,
          animate: "enter",
          custom: images.length - index,
          "data-group": true,
          exit: "exit",
          initial: isInitialRender ? false : {
            opacity: 0
          },
          onClick: function onClick() {
            void open(index);
          },
          variants: variants,
          children: [jsx(AspectRatio, {
            ratio: 4 / 3,
            children: jsx(Image$1, {
              __css: styles.gridImage,
              alt: title !== null && title !== void 0 ? title : "Photo ".concat(index + 1),
              src: thumbnail !== null && thumbnail !== void 0 ? thumbnail : url
            })
          }), showHover && jsx(Center, {
            sx: styles.gridImageHoverTarget,
            children: jsx(AspectRatio, {
              ratio: 1,
              sx: styles.gridImageHoverBody,
              children: jsx(Icon, {
                icon: iMaximize,
                isInline: true,
                size: "huge",
                sx: styles.gridImageHoverIcon
              })
            })
          }), jsx(LoadingState, {
            isLoading: currentIndex === index && isLoading,
            sx: styles.modalLoading
          })]
        }, url);
      })
    })
  }));
};

var _excluded$5 = ["direction", "variant"];
var GalleryArrowButton = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var direction = _ref.direction,
    variant = _ref.variant,
    props = _objectWithoutProperties(_ref, _excluded$5);
  var styles = useGalleryStyles();
  var isPrevious = direction === 'previous';
  var carretIcon = isPrevious ? iChevronLeft : iChevronRight;
  var arrowIcon = isPrevious ? iconArrowLeft : iconArrowRight;
  var buttonArrow = variant === 'dark' ? arrowIcon : carretIcon;
  return jsx(system.button, _objectSpread2(_objectSpread2({}, props), {}, {
    __css: _objectSpread2(_objectSpread2({}, styles.arrowTarget), isPrevious ? styles.arrowTargetPrevious : styles.arrowTargetNext),
    "data-group": true,
    ref: ref,
    sx: resetFocus(),
    children: jsx(Center, {
      sx: _objectSpread2(_objectSpread2({}, styles.arrowBody), isPrevious ? styles.arrowBodyPrevious : styles.arrowBodyNext),
      children: jsx(IconButton, {
        as: "div",
        icon: buttonArrow,
        iconSize: "medium",
        label: isPrevious ? 'Previous' : 'Next',
        sx: _objectSpread2({}, styles.arrowIcon),
        variant: "secondary"
      })
    })
  }));
});

var _excluded$4 = ["enableSwipe", "hideButtons", "imageProps", "variant", "isMotionReduced", "nextButtonRef", "renderSlideContent"];
var shouldSlide = function shouldSlide(action) {
  return includes(['next', 'previous'], action);
};
var GallerySlideCarousel = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var _renderSlideContent;
  var _ref$enableSwipe = _ref.enableSwipe,
    enableSwipe = _ref$enableSwipe === void 0 ? true : _ref$enableSwipe,
    _ref$hideButtons = _ref.hideButtons,
    hideButtons = _ref$hideButtons === void 0 ? false : _ref$hideButtons,
    imageProps = _ref.imageProps,
    variant = _ref.variant,
    isMotionReducedProp = _ref.isMotionReduced,
    nextButtonRef = _ref.nextButtonRef,
    _ref$renderSlideConte = _ref.renderSlideContent,
    renderSlideContent = _ref$renderSlideConte === void 0 ? undefined : _ref$renderSlideConte,
    props = _objectWithoutProperties(_ref, _excluded$4);
  var isMotionReduced = useIsMotionReduced(isMotionReducedProp);
  var _useGalleryContext = useGalleryContext(),
    action = _useGalleryContext.action,
    currentImage = _useGalleryContext.currentImage,
    disable = _useGalleryContext.disable,
    enable = _useGalleryContext.enable,
    getNextButtonProps = _useGalleryContext.getNextButtonProps,
    getPreviousButtonProps = _useGalleryContext.getPreviousButtonProps,
    images = _useGalleryContext.images,
    isLoading = _useGalleryContext.isLoading,
    next = _useGalleryContext.next,
    previous = _useGalleryContext.previous,
    progress = _useGalleryContext.progress;
  var showButtons = !hideButtons && images.length > 1;
  var styles = useGalleryStyles();
  var slide = function slide(a, n, p) {
    if (!shouldSlide(a) || isMotionReduced) return 0;
    return a === 'next' ? n : p;
  };
  var isDarkVariant = variant === 'dark';
  var variants = {
    enter: {
      x: isDarkVariant ? "".concat(slide(action, 100, -100), "%") : "".concat(slide(action, 25, -25), "%"),
      opacity: shouldSlide(action) ? 0 : 1
    },
    center: {
      zIndex: 1,
      x: '0%',
      opacity: 1
    },
    exit: function exit(a) {
      return {
        zIndex: 0,
        x: isDarkVariant ? "".concat(slide(a, -100, 100), "%") : "".concat(slide(a, -25, 100), "%"),
        opacity: 0
      };
    }
  };
  var animationContentProps = {
    animate: 'center',
    cursor: 'grab',
    drag: enableSwipe ? 'x' : false,
    dragConstraints: {
      left: 0,
      right: 0
    },
    dragElastic: 1,
    exit: 'exit',
    initial: 'enter',
    onAnimationComplete: isDarkVariant ? function () {
      return null;
    } : enable,
    onAnimationStart: isDarkVariant ? function () {
      return null;
    } : disable,
    onDragEnd: onSwipe({
      axis: 'x',
      start: next,
      end: previous
    }),
    variants: variants
  };
  return jsx(MotionConfig, {
    transition: isDarkVariant ? {
      type: 'spring',
      bounce: 0,
      damping: 50,
      stiffness: 300
    } : {
      duration: 0.25,
      bounce: 0
    },
    children: jsxs(Center, _objectSpread2(_objectSpread2({}, props), {}, {
      ref: ref,
      sx: _objectSpread2({}, styles.modalImageContainer),
      children: [showButtons && jsx(GalleryArrowButton, _objectSpread2({
        direction: "previous",
        variant: variant
      }, getPreviousButtonProps())), images.length > 0 && jsx(AnimatePresence, {
        custom: action,
        mode: "popLayout",
        children: createElement(motion.div, _objectSpread2(_objectSpread2({}, animationContentProps), {}, {
          key: currentImage.url
        }), (_renderSlideContent = renderSlideContent === null || renderSlideContent === void 0 ? void 0 : renderSlideContent(currentImage)) !== null && _renderSlideContent !== void 0 ? _renderSlideContent : createElement(Image$1, _objectSpread2(_objectSpread2({
          alt: progress,
          borderRadius: "300",
          draggable: false,
          height: "auto"
        }, imageProps), {}, {
          key: currentImage.url,
          maxWidth: "100%",
          src: currentImage.url,
          sx: styles.modalImage
        })))
      }), showButtons && jsx(GalleryArrowButton, _objectSpread2({
        direction: "next",
        variant: variant
      }, getNextButtonProps({
        ref: nextButtonRef
      }))), jsx(LoadingState, {
        background: variant === 'dark' ? 'overlayDark' : 'overlayLight',
        color: variant === 'dark' ? 'neutral.0' : 'neutral.900',
        delay: 100,
        isLoading: isLoading,
        size: "huge",
        sx: styles.modalLoading
      })]
    }))
  });
});

var _excluded$3 = ["title", "isMotionReduced", "maxContentHeight", "variant", "renderSlideContent", "showProgress", "onClose"];
var GalleryModal = function GalleryModal(_ref) {
  var title = _ref.title,
    isMotionReduced = _ref.isMotionReduced,
    _ref$maxContentHeight = _ref.maxContentHeight,
    maxContentHeight = _ref$maxContentHeight === void 0 ? 800 : _ref$maxContentHeight,
    variant = _ref.variant,
    _ref$renderSlideConte = _ref.renderSlideContent,
    renderSlideContent = _ref$renderSlideConte === void 0 ? undefined : _ref$renderSlideConte,
    _ref$showProgress = _ref.showProgress,
    showProgress = _ref$showProgress === void 0 ? true : _ref$showProgress,
    onClose = _ref.onClose,
    props = _objectWithoutProperties(_ref, _excluded$3);
  var _useGalleryContext = useGalleryContext(),
    close = _useGalleryContext.close,
    isOpen = _useGalleryContext.isOpen,
    progress = _useGalleryContext.progress,
    currentImage = _useGalleryContext.currentImage;
  var initialFocusRef = useRef(null);
  var styles = useGalleryStyles();
  var onCloseAction = callAllHandlers(onClose, close);
  return jsx(Modal, _objectSpread2(_objectSpread2({
    bodyProps: {
      as: 'figure',
      sx: styles.modalBody
    },
    closeButtonProps: {
      sx: styles.modalCloseButton
    },
    contentProps: {
      sx: styles.modalContent
    },
    footer: showProgress ? jsx(Body, {
      as: "figcaption",
      sx: styles.modalProgress,
      children: progress
    }) : jsx(Spacer, {
      flex: 0
    }),
    footerProps: {
      sx: styles.modalFooter
    },
    header: jsx(Heading, {
      as: "h1",
      sx: styles.modalHeading,
      children: typeof title === 'function' ? title(currentImage) : title
    }),
    headerProps: {
      sx: styles.modalHeader
    },
    initialFocusRef: initialFocusRef,
    isOpen: isOpen,
    onClose: onCloseAction,
    size: "auto"
  }, props), {}, {
    children: jsx(GallerySlideCarousel, {
      imageProps: {
        maxHeight: maxContentHeight
      },
      isMotionReduced: isMotionReduced,
      nextButtonRef: initialFocusRef,
      renderSlideContent:
      // The type assertion is a temporary fix until we can figure out how to make the generic work
      renderSlideContent,
      variant: variant
    })
  }));
};

var _excluded$2 = ["children", "currentIndex", "images", "isExpanded", "isMotionReduced", "isOpen", "keys", "limit", "nextLabel", "onClose", "previousLabel", "size", "progressText", "title", "variant", "maxContentHeight", "renderSlideContent", "showProgress"];
var Gallery = function Gallery(_ref) {
  var children = _ref.children,
    currentIndex = _ref.currentIndex,
    images = _ref.images,
    isExpanded = _ref.isExpanded,
    isMotionReduced = _ref.isMotionReduced,
    isOpen = _ref.isOpen,
    keys = _ref.keys,
    limit = _ref.limit,
    nextLabel = _ref.nextLabel,
    onClose = _ref.onClose,
    previousLabel = _ref.previousLabel,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 'auto' : _ref$size,
    progressText = _ref.progressText,
    title = _ref.title,
    variant = _ref.variant,
    maxContentHeight = _ref.maxContentHeight,
    renderSlideContent = _ref.renderSlideContent,
    showProgress = _ref.showProgress,
    props = _objectWithoutProperties(_ref, _excluded$2);
  var styles = useMultiStyleConfig('Gallery', _objectSpread2(_objectSpread2({}, props), {}, {
    size: size,
    variant: variant
  }));
  return jsx(GalleryProvider, {
    currentIndex: currentIndex,
    images: images,
    isExpanded: isExpanded,
    isOpen: isOpen,
    keys: keys,
    limit: limit,
    nextLabel: nextLabel,
    previousLabel: previousLabel,
    progressText: progressText,
    children: jsx(GalleryStylesProvider, {
      value: styles,
      children: children !== null && children !== void 0 ? children : jsxs(Fragment, {
        children: [jsx(GalleryGrid, _objectSpread2({
          isMotionReduced: isMotionReduced,
          spacing: "300"
        }, props)), jsx(GalleryModal, {
          isMotionReduced: isMotionReduced,
          maxContentHeight: maxContentHeight || undefined,
          onClose: onClose,
          renderSlideContent: renderSlideContent,
          showProgress: showProgress,
          size: size,
          title: title,
          variant: variant
        })]
      })
    })
  });
};

var _excluded$1 = ["direction"];
var FullscreenGalleryArrowButton = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var direction = _ref.direction,
    props = _objectWithoutProperties(_ref, _excluded$1);
  var styles = useGalleryStyles();
  var isPrevious = direction === 'previous';
  var buttonArrow = isPrevious ? iChevronLeft : iChevronRight;
  return jsx(system.button, _objectSpread2(_objectSpread2({
    "data-group": true,
    ref: ref,
    sx: _objectSpread2(_objectSpread2({}, styles.arrowFullScreenTarget), isPrevious ? styles.arrowFullScreenTargetPrevious : styles.arrowFullScreenTargetNext)
  }, props), {}, {
    children: jsxs(Center, {
      sx: styles.arrowFullScreenBody,
      children: [jsx(Icon, {
        icon: buttonArrow,
        isInline: true,
        size: "huge",
        sx: styles.arrowFullScreenIconAccent
      }), jsx(Icon, {
        icon: buttonArrow,
        size: "huge",
        sx: styles.arrowFullScreenIcon
      })]
    })
  }));
});

var _excluded = ["hidePagingInstructions", "hideZoomInstructions", "isMotionReduced", "maxContentHeight", "title", "zoomOptions", "variant"],
  _excluded2 = ["onWheel"];
var FullscreenGalleryModal = function FullscreenGalleryModal(_ref) {
  var _ref$hidePagingInstru = _ref.hidePagingInstructions,
    hidePagingInstructions = _ref$hidePagingInstru === void 0 ? false : _ref$hidePagingInstru,
    _ref$hideZoomInstruct = _ref.hideZoomInstructions,
    hideZoomInstructions = _ref$hideZoomInstruct === void 0 ? false : _ref$hideZoomInstruct,
    isMotionReduced = _ref.isMotionReduced,
    _ref$maxContentHeight = _ref.maxContentHeight,
    maxContentHeight = _ref$maxContentHeight === void 0 ? 'calc(100vh - 132px)' : _ref$maxContentHeight,
    title = _ref.title,
    zoomOptions = _ref.zoomOptions;
    _ref.variant;
    var props = _objectWithoutProperties(_ref, _excluded);
  var _useBoolean = useBoolean(hideZoomInstructions),
    _useBoolean2 = _slicedToArray(_useBoolean, 2),
    hasZoomed = _useBoolean2[0],
    setHasZoomed = _useBoolean2[1].on;
  var _useBoolean3 = useBoolean(hidePagingInstructions),
    _useBoolean4 = _slicedToArray(_useBoolean3, 2),
    hasPaged = _useBoolean4[0],
    setHasPaged = _useBoolean4[1].on;
  var _useZoom = useZoom(zoomOptions),
    _useZoom$props = _useZoom.props,
    _onWheel = _useZoom$props.onWheel,
    zoom = _objectWithoutProperties(_useZoom$props, _excluded2),
    resize = _useZoom.resize,
    isZoomed = _useZoom.isZoomed;
  var _useGalleryContext = useGalleryContext(),
    action = _useGalleryContext.action,
    close = _useGalleryContext.close,
    getNextButtonProps = _useGalleryContext.getNextButtonProps,
    getPreviousButtonProps = _useGalleryContext.getPreviousButtonProps,
    isDisabled = _useGalleryContext.isDisabled,
    isOpen = _useGalleryContext.isOpen,
    progress = _useGalleryContext.progress,
    currentImage = _useGalleryContext.currentImage;
  var initialFocusRef = useRef(null);
  var styles = useGalleryStyles();
  useEffect(function () {
    window.addEventListener('resize', resize);
    return function () {
      return window.removeEventListener('resize', resize);
    };
  }, [resize]);
  if (isZoomed && !hasZoomed) setHasZoomed();
  useEffect(function () {
    var timeout = null;
    if (action === 'next' || action === 'previous') setHasPaged();
    if (action === 'open') {
      timeout = window.setTimeout(function () {
        return setHasPaged();
      }, 5000);
    }
    return function () {
      if (timeout) clearTimeout(timeout);
    };
  }, [action, setHasPaged]);
  return jsx(Modal, _objectSpread2(_objectSpread2({
    bodyProps: {
      as: 'figure',
      sx: styles.modalFullScreenBody
    },
    contentProps: {
      sx: styles.modalFullScreenContent
    },
    footer: jsx(Body, {
      as: "figcaption",
      sx: styles.modalProgress,
      children: progress
    }),
    footerProps: {
      sx: styles.modalFooter
    },
    header: jsx(Heading, {
      as: "h1",
      sx: styles.modalHeading,
      children: typeof title === 'function' ? title(currentImage) : title
    }),
    initialFocusRef: initialFocusRef,
    isOpen: isOpen,
    onClose: close,
    size: "full"
  }, props), {}, {
    children: jsxs(HStack, {
      alignItems: "stretch",
      width: "100%",
      children: [jsx(FullscreenGalleryArrowButton, _objectSpread2(_objectSpread2({}, getPreviousButtonProps()), {}, {
        direction: "previous"
      })), jsxs(system.div, {
        position: "relative",
        children: [jsx(GallerySlideCarousel, {
          enableSwipe: !isZoomed,
          hideButtons: true,
          imageProps: _objectSpread2({
            cursor: isZoomed ? 'grab' : 'zoom-in',
            maxHeight: maxContentHeight,
            onWheel: function onWheel(event) {
              if (isDisabled) return;
              setHasZoomed();
              _onWheel(event);
            }
          }, zoom),
          isMotionReduced: isMotionReduced
        }), jsxs(HStack, {
          sx: _objectSpread2(_objectSpread2({}, styles.helperOverlayZoomContainer), hasZoomed && styles.helperOverlayHidden),
          children: [jsx(Icon, {
            icon: hUpDown,
            isInline: true,
            size: "medium"
          }), jsx(Body, {
            my: "0",
            children: "Scroll to zoom"
          })]
        }), jsxs(HStack, {
          sx: _objectSpread2(_objectSpread2({}, styles.helperOverlayHotKeysContainer), hasPaged && styles.helperOverlayHidden),
          children: [jsx(Body, {
            mr: "200",
            my: "0",
            children: "Arrow keys"
          }), jsx(Hotkey, {
            sx: styles.helperOverlayHotKey,
            children: jsx(Icon, {
              icon: iArrowLeft
            })
          }), jsx(Hotkey, {
            sx: styles.helperOverlayHotKey,
            children: jsx(Icon, {
              icon: iArrowRight
            })
          })]
        })]
      }), jsx(FullscreenGalleryArrowButton, _objectSpread2(_objectSpread2({}, getNextButtonProps({
        ref: initialFocusRef
      })), {}, {
        direction: "next"
      }))]
    })
  }));
};

export { FullscreenGalleryModal, Gallery, GalleryArrowButton, GalleryGrid, GalleryModal, GallerySlideCarousel, useGallery, useGalleryContext };
